import { defineComponent as V, openBlock as o, createElementBlock as e, mergeProps as p, unref as n, renderSlot as u, createElementVNode as a, createCommentVNode as i } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, A = { key: 1 }, Z = { key: 2 }, f = { key: 3 }, k = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconSquare"
}, _ = /* @__PURE__ */ V({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: H, weight: l } = m(s);
    return (d, t) => (o(), e("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(H)), [
      u(d.$slots, "default"),
      n(l) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        a("path", { d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204Z" }, null, -1)
      ]))) : n(l) === "duotone" ? (o(), e("g", A, t[1] || (t[1] = [
        a("path", {
          d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Z" }, null, -1)
      ]))) : n(l) === "fill" ? (o(), e("g", Z, t[2] || (t[2] = [
        a("path", { d: "M224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Z" }, null, -1)
      ]))) : n(l) === "light" ? (o(), e("g", f, t[3] || (t[3] = [
        a("path", { d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : n(l) === "regular" ? (o(), e("g", k, t[4] || (t[4] = [
        a("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Z" }, null, -1)
      ]))) : n(l) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        a("path", { d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
